import crypto from 'crypto';

function secureDecode(encoded: string): string {
  const passphrase: string | undefined = process.env.CRYPTO_PASSPHRASE;
  if (!passphrase) {
    return encoded;
  }
  const [saltHex, ivHex, encrypted] = encoded.split(':');
  const salt = Buffer.from(saltHex, 'hex');
  const iv = Buffer.from(ivHex, 'hex');
  const key = crypto.pbkdf2Sync(passphrase, salt, 100000, 32, 'sha256');
  const decipher = crypto.createDecipheriv('aes-256-cbc', key, iv);
  let decrypted = decipher.update(encrypted, 'hex', 'utf8');
  decrypted += decipher.final('utf8');
  return decrypted;
}

export { secureDecode };
